"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getScreenSizeBucket = exports.mediaMaxWidthLarge = exports.mediaMaxWidthMedium = exports.mediaMaxWidthSmall = exports.mediaMaxWidthXtraSmall = exports.screenSizes = exports.wide = exports.huge = exports.large = exports.medium = exports.small = void 0;
var smallPixelCount = 576;
var mediumPixelCount = 768;
var largePixelCount = 992;
var hugePixelCount = 1200;
var widePixelCount = 1366;
// Small devices (landscape phones, 576px and up)
exports.small = "".concat(smallPixelCount, "px");
// Medium devices (tablets, 768px and up)
exports.medium = "".concat(mediumPixelCount, "px");
// Large devices (desktops, 992px and up)
exports.large = "".concat(largePixelCount, "px");
// Extra large devices (large desktops, 1200px and up)ß
exports.huge = "".concat(hugePixelCount, "px");
// Wide screens devices (large desktops, 1366px and up)
exports.wide = "".concat(widePixelCount, "px");
// Batch screensizes into one object
exports.screenSizes = {
    small: exports.small,
    medium: exports.medium,
    large: exports.large,
    huge: exports.huge,
    wide: exports.wide,
};
//only specifying max-widths because existing code already has the pattern which
//works: @media (min-width: ${screenSizes.small}).
//max-width needs 1 less than above numbers.
exports.mediaMaxWidthXtraSmall = "@media (max-width: ".concat(smallPixelCount - 1, "px)");
exports.mediaMaxWidthSmall = "@media (max-width: ".concat(mediumPixelCount - 1, "px)");
exports.mediaMaxWidthMedium = "@media (max-width: ".concat(largePixelCount - 1, "px)");
exports.mediaMaxWidthLarge = "@media (max-width: ".concat(hugePixelCount - 1, "px)");
// for analytics of screen size distributions
var getScreenSizeBucket = function () {
    var width = window.screen.width;
    if (width < 480) {
        return '< 480';
    }
    if (width >= 480 && width < 768) {
        return '480 - 768';
    }
    if (width >= 768 && width < 1020) {
        return '768 - 1020';
    }
    if (width >= 1020 && width < 1440) {
        return '1020 - 1440';
    }
    if (width >= 1440 && width < 1920) {
        return '1440 - 1920';
    }
    return '> 1920';
};
exports.getScreenSizeBucket = getScreenSizeBucket;
//# sourceMappingURL=screenSizes.js.map